export const CONNECTIVITY_CONFIG = {
  offline: {
    title: 'No connection',
    text: 'You are offline. Changes may not be saved until your connection is restored.',
  },

  online: {
    title: 'Back online',
    text: 'Your connection has been restored.',
  },

  /** How long the "Back online" toast stays up, in ms. */
  onlineToastDelay: 4000,

  /** How often we re-check the api while it is unreachable, in ms. */
  probeInterval: 5000,

  /** How long the connection must stay up before we announce "Back online", in ms. */
  onlineStabilityDelay: 2000,
} as const;
